<template>
  <div class="banner-page-view-multi">
    <div class="swiper-prev"></div>
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide"  v-for="(item,index) in bannerList">
          <div class="banner-show">
            <img class="bannerImg" :src="item.imgUrl" alt="" />
            <p>{{item.content}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-next"></div>
  </div>
</template>
<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  export default{
    name: 'BannerSwiper',
    data(){
      return {
      };
    },
    props: {
      bannerList: Array,
      bannerSlidesPerView:Number,
      bannerSlidesPerColumn:Number
    },
    computed: {
    },
    components: {},
    methods: {
      bannerSwiper: function () {
        this.circulationSwiper = new Swiper('.swiper-container', {
//          autoplay: 3000,
          slidesPerView: this.bannerSlidesPerView,
          slidesPerColumn: this.bannerSlidesPerColumn,
          spaceBetween: 30,
          nextButton: '.swiper-next',
          prevButton: '.swiper-prev',
          onClick: swiperbanner => {
            let index = swiperbanner.clickedIndex;
            this.$emit('actionClickBanner', index);
          }
        });
      }
    },
    created: function () {
    },
    mounted: function () {
      this.bannerSwiper();
    }
  };
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .banner-page-view-multi{
    position: relative;
  .swiper-container {
    .swiper-wrapper {
    }
    .swiper-slide{
      background:$color-4;
      .banner-show{
        cursor: pointer;
        position: relative;
        z-index:2;
        border:1px solid transparent;
        &:hover{
          box-shadow: 1px 0 10px #ccc;
        }
        .bannerImg {
          width:100%;
        }
        p{
          color:$color-1;
          font-size:22px;
          padding:30px 0;
          span{
            color:#ffc63d;
          }
        }
      }
    }
  }
    .swiper-next{
      width:40px;
      height:40px;
      background-image:url(./image/swiper-button-next.jpg);
      background-size:100% 100%;
      position: absolute;
      top:47.8%;right:-6%;
      transform: translate(-50%, 0);
      z-index:10;
      cursor: pointer;
    }
    .swiper-prev{
      width:40px;
      height:40px;
      background-image:url(./image/swiper-button-prev.jpg);
      background-size:100% 100%;
      position: absolute;top:47.8%;left:-3%;
      transform: translate(-50%, 0);
      z-index:10;
      cursor: pointer;
    }
  }
</style>
